// extracted by mini-css-extract-plugin
module.exports = {"content":"ACConsumption_content__3wllU","headerContainer":"ACConsumption_headerContainer__4fwYX","headerIcon":"ACConsumption_headerIcon__1qDLj","cell":"ACConsumption_cell__xje8_"};